import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import MatchingRunInstance from './matchingRunInstance';
import {
  getNSGlobalSettingsPageInfo,
  getPageItemOperations
} from '../../../redux/actions/settings';
import {
  configRunInstance,
  getNSRunInstanceResultListData,
  getNSRunInstanceSummaryData,
  postRunRunInstance,
  getRunInstanceViewExecution
} from '../../../redux/actions/ns/runInstance';
import { fetchAMLSAlertLevel } from '../../../redux/actions/common';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    runInstanceResultListData: state.nsRunInstanceConfig.runInstanceResultList,
    runInstanceSummaryData: state.nsRunInstanceConfig.runInstanceSummary,
    settings: state.settings,
    runRunInstance: state.nsRunInstanceConfig.runRunInstance,
    widgetItemOperations: state.settings.widgetItemOperations,
    runInstanceViewExecution:
      state.nsRunInstanceConfig.runInstanceViewExecution,
    alertLevels: state.amlsCommon.alertLevelConfigs.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path, state) => push(path, state),
        getNSGlobalSettingsPageInfo,
        configRunInstance,
        getNSRunInstanceResultListData,
        getNSRunInstanceSummaryData,
        postRunRunInstance,
        getPageItemOperations,
        getRunInstanceViewExecution,
        fetchAMLSAlertLevel
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MatchingRunInstance);
